module.exports = __webpack_public_path__ + "img/c-b3.8a4fc535.png";